'use client'

import { ScheduleCallCTA } from '~/components/ScheduleCallCTA'

export const HERO_CTA_ID = 'hero-cta'

export const HeroCTA = () => (
  <ScheduleCallCTA id={HERO_CTA_ID} segmentElement="Hero CTA" className="w-full text-blue-darkest tablet:w-[459px]">
    Schedule a call
  </ScheduleCallCTA>
)
